export class FacturacionGuiaRequest {
   dtes: string[];
   sucursalId: string;
   usuarioId: string;
   formaPago: number;
   incluirDocumentosReferenciados: boolean = false;
}
